import { useEffect } from 'react';

import type { ErrorLog, LogErrorRequest } from '@common/types/LogErrorRequest';
import type { NextError } from '@common/types/NextError';

function getErrorLog(untypedError: unknown): ErrorLog {
    if (!(untypedError instanceof Error)) {
        return { message: String(untypedError) };
    }

    const error = untypedError as NextError;

    const json: ErrorLog = {
        digest: error.digest,
        message: error.message,
        name: error.name,
        stack: error.stack,
    };

    if (error.cause !== undefined) {
        json.cause = getErrorLog(error.cause);
    }

    return json;
}

export const useErrorLogger = (error: unknown, scope: string) => {
    useEffect(() => {
        const request: LogErrorRequest = {
            error: getErrorLog(error),
            url: document.location.href,
            scope,
        };

        void fetch('/api/log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
    }, [error, scope]);
};
